/**
 * Utility functions for handling loading states and splash screens
 */

// Global initialization state to track if the app has been loaded
let appInitialized = false;

/**
 * Get current app initialization state
 * @returns {boolean} True if app has been initialized
 */
export const isAppInitialized = (): boolean => {
  return appInitialized;
};

/**
 * Mark app as initialized after initial loading
 */
export const setAppInitialized = (): void => {
  appInitialized = true;
};

/**
 * Reset app initialization state (useful for testing)
 */
export const resetAppInitialization = (): void => {
  appInitialized = false;
};

/**
 * Delay function using promises
 * @param {number} ms - Milliseconds to delay
 * @returns {Promise<void>}
 */
export const delay = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
}; 